import * as React from "react";
import { Children, SetStateAction, useContext } from "react";
import { ViewTradeBCheckButton } from "src/components/common/BcheckView/ViewTradeBCheckButton";
import { ViewTradeCommissionButton } from 'src/components/common/CommissionView/ViewTradeCommissionButton';
import { ViewTedButton } from 'src/components/common/GenericButtons/ViewTedButton/ViewTedButton';
import { AuthContext } from "src/components/context/AuthContext";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { formatDate } from "src/util/formatDate";
import ArchiveButton from "../Archive/ArchiveButton";
import { ArchiveButtonTypeEnum } from "../Archive/ArchiveButtonTypeEnum";
import "./actionButtons.scss";
import { ClientInfo } from "./Components/ClientInfo/ClientInfo";
import { Documents } from "./Components/Documents/Documents";
import { GeneralInfo } from "./Components/GeneralInfo/GeneralInfo";
import { LawyerInfo } from "./Components/LawyerInfo/LawyerInfo";
import { PricingInfo } from "./Components/PricingInfo/PricingInfo";
import { SpouseInfo } from "./Components/SpouseInfo/SpouseInfo";
import { ProxyDownloadButton } from '../DownloadButtons/ProxyDownloadButton/ProxyDownloadButton';
import * as _ from 'lodash';
import { ViewCertificatesButton } from "src/pages/step-flow/steps/certificates/ViewCertificatesButton";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { RejectPrePrecatorioButton } from '../RejectPrePrecatorio/RejectPrePrecatorioButton';

interface ITradeDetailView {
  currentTrade: ITrade;
  childrens: any;
  setLoading: React.Dispatch<SetStateAction<boolean>>;
  updateList: () => void;
  reloadTrade: (tradeID: number) => void;
  hideComissionEditButton?: boolean;
  isArchiveEnabled: boolean;
}

export function TradeDetailView(props: ITradeDetailView) {
  const { currentUser } = useContext(AuthContext);
  const trade = props.currentTrade;
  const certificatePhases = [TradePhaseEnum.SellChoice, TradePhaseEnum.Created, TradePhaseEnum.ContractInformation, TradePhaseEnum.BankInfo, TradePhaseEnum.DocumentValidation, TradePhaseEnum.DocumentApproval, TradePhaseEnum.LegalCertificates, TradePhaseEnum.ContractSignatureAcceptenceTerm, TradePhaseEnum.Analysis, TradePhaseEnum.SpecialProjectApproved, TradePhaseEnum.SpecialProjectValid, TradePhaseEnum.Diligence]

  const clonedChildrensWithTradeProps = Children.map(props.childrens, child => {
    if (child.props.hidenAsAChildren && child.props.hidenAsAChildren(props.currentTrade)) {
      return <></>;
    }
    return (React.cloneElement(child, { trade: props.currentTrade, setLoading: props.setLoading, updateParent: props.updateList, reloadTrade: props.reloadTrade }));
  });

  return (
    <>
      <div className="header">
        <div className="left">
          <span className="id-header">Trade ID</span>
          <span className="id">{trade.id}</span>
        </div>
        <div className="right">
          <span className="date-header">Última atualização</span>
          <span className="date">{formatDate(trade.lastUpdate)}</span>
        </div>
      </div>

      <div className="row">
        <div className="region-container action-buttons">
          <span className="subtitle">Ações</span>
          <div className="default-actions">
            <ViewTradeBCheckButton trade={trade} />
            {props.isArchiveEnabled && (
              <ArchiveButton
                setLoading={props.setLoading}
                trade={trade}
                type={trade.isArchived ? ArchiveButtonTypeEnum.unarchive : ArchiveButtonTypeEnum.archive}
                updateParent={props.updateList}
                showButtonLabel
              />
            )}
            {certificatePhases.filter(x => x === trade.phase).length > 0 && <ViewCertificatesButton trade={props.currentTrade} />}
            <ProxyDownloadButton
              trade={trade}
              disabled={_.isEmpty(trade.precatorio.urlProcessFile)}
              documents={[
                { url: trade.precatorio.urlProcessFile, name: `${trade.precatorio.processCode}.pdf` }
              ]}
            >
              Baixar Ofício
            </ProxyDownloadButton>
            {!props.hideComissionEditButton &&
              <ViewTradeCommissionButton
                currentTrade={trade}
                reloadTrade={props.reloadTrade}
              />}

            {trade?.idPrePrecatorio && certificatePhases.filter(x => x === trade.phase).length > 0 &&
              <RejectPrePrecatorioButton
                idPrePrecatorio={trade?.idPrePrecatorio}
                setLoading={props.setLoading}
                onReject={() => props.reloadTrade(trade.id)}
                title="Deseja Rejeitar o Trade? Informe qualquer detalhe adicional"
              />
            }
            <ViewTedButton trade={trade} setLoading={props.setLoading} />
          </div>
          <div className="extra-actions">{clonedChildrensWithTradeProps}</div>
        </div>
      </div>

      <div className="row">
        <GeneralInfo trade={trade} />
        <div className="col pricing-info">
          <ClientInfo tradeOwner={trade.tradeOwner} />
        </div>
        <div className="col pricing-info">
          {trade.lawyer && <LawyerInfo lawyer={trade.lawyer} />}
          {trade.tradeOwner?.spouse && <SpouseInfo spouse={trade.tradeOwner.spouse} />}
        </div>
      </div>
      <div className="row">
        <div className="col pricing-info">
          <PricingInfo trade={trade} userCanSeeCommission={currentUser.permissions.userCanSeeCommission} />
        </div>
        <div className="col documents">
          <Documents documentList={trade.documentList} />
        </div>
      </div>
    </>
  );
}

export default TradeDetailView;



// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/TradeDetailView.tsx